import $ from "jquery";
import 'slick-carousel';

export const quoteSlider = () => {
    $('.quote').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true
    });
};
